module.exports = __webpack_public_path__ + "img/index11.b29e0c31.jpg";